import apiService from 'src/enviroment';
import { loaderService } from 'src/services/loaderService';

const getFiles = async (id) => {
  loaderService.show();
  const response = await apiService.get(
    `insights/admin/entradas/adjuntos/?tipo=entradas&id_entrada=${id}`,
  );
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const getDetails = async (id) => {
  loaderService.show();
  try {
    const response = await apiService.get(
      `insights/admin/entradas/sistema/?tipo=id&id=${id}`,
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const putDetails = async (params) => {
  loaderService.show();
  const response = await apiService.put(
    'insights/admin/entradas/sistema/',
    params,
  );
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};
const postFiles = async (params) => {
  loaderService.show();
  const response = await apiService.post(
    'insights/admin/entradas/adjuntos/',
    params,
  );
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const deleteFile = async (id) => {
  loaderService.show();
  try {
    const response = await apiService.delete(
      `insights/admin/entradas/adjuntos/?id=${id}`,
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const getUrl = async (id) => {
  loaderService.show();
  try {
    const response = await apiService.get(
      `insights/admin/entradas/adjuntos/?tipo=id&id=${id}`,
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const deleteInsight = async (params) => {
  loaderService.show();
  try {
    const response = await apiService.put(
      '/insights/admin/entradas/sistema/',
      params,
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const postDetail = async (params) => {
  loaderService.show();
  try {
    const response = await apiService.post(
      'insights/admin/entradas/sistema/historico/',
      params,
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const postLike = async (params) => {
  try {
    const response = await apiService.post('insights/admin/pruebas/likes/', params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

const getImage = async (id) => {
  loaderService.show();
  try {
    const response = await apiService.get(
      `insights/admin/entrada/icono/adjunto/?id_entrada=${id}`,
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};
const postImage = async (params) => {
  loaderService.show();
  try {
    const response = await apiService.post(
      'insights/admin/entrada/icono/adjunto/',
      params,
    );
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

export {
  getUrl,
  getImage,
  getFiles,
  postLike,
  postFiles,
  postImage,
  postDetail,
  putDetails,
  getDetails,
  deleteFile,
  deleteInsight,
};
